import { useContext } from 'react';
import { MyHomeContext } from './MyHomeProvider';

export function useMyHome() {
    return useContext(MyHomeContext);
}
